import { useContext, useEffect, useRef } from "react";
import { Auth, API } from "aws-amplify";
import Context from "./Context/Context";
import InstitutionContext from "./Context/InstitutionContext";
import RoutesContainer from "./Routes";
import LoaderProvider from "./Components/LoaderProvider";

function App() {
    const UtilCtx = useRef(useContext(Context).util);
    const UserCtx = useRef(useContext(Context));
console.log(process.env.REACT_APP_STAGE)
    useEffect(() => {
        const check = async () => {
            UtilCtx.current.setLoader(true);

            try {
                await Auth.currentAuthenticatedUser();
                const userdata = await API.get("user", "/user/profile/Bworkz");
                UserCtx.current.setUserData(userdata);
                UserCtx.current.setIsAuth(true);
                UtilCtx.current.setLoader(false);
            } catch (e) {
                console.log(e);
                UserCtx.current.setUserData({});
                UtilCtx.current.setLoader(false);
            }
        };
        check();
    }, []);

    const institutionData = {
        PrimaryColor: '#1a73e8',
        SecondaryColor: '#4285f4',
        lightPrimaryColor: '#e8f0fe'
    };

    return (
        <InstitutionContext.Provider value={{ institutionData }}>
            <LoaderProvider>
                <RoutesContainer />
            </LoaderProvider>
        </InstitutionContext.Provider>
    );
}

export default App;

